import { useEffect, useMemo, useState } from 'react';

export const useWindowSize = () => {
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};

export const useIsMobile = () => {
  const windowSize = useWindowSize();
  return useMemo(() => windowSize <= 640, [windowSize]);
};
